import { Store, Module, ActionContext } from "vuex";
import ListModule from "./list-module";
import ListState from "./list-state";
import Ajax from "../../lib/ajax";
import PageResult from "@/store/entities/page-result";
import ListMutations from "./list-mutations";
import Category from "../entities/category";
import CategoryForSelect from "../entities/categoryForSelect";
import appconst from "./../../lib/appconst";

interface CategoryState extends ListState<Category> {
  editCategory: Category;
  categoriesForSelect: CategoryForSelect[];
  parentCategoriesForSelect: CategoryForSelect[];
  categoriesOfClientForSelect: CategoryForSelect[];
}
class CategoryMutations extends ListMutations<Category> {}
class CategoryModule extends ListModule<CategoryState, any, Category> {
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<Category>(),
    loading: false,
    editCategory: new Category(),
    categoriesForSelect: new Array<CategoryForSelect>(),
    parentCategoriesForSelect: new Array<CategoryForSelect>(),
    categoriesOfClientForSelect: new Array<CategoryForSelect>(),
  };
  actions = {
    async getAll(context: ActionContext<CategoryState, any>, payload: any) {
      context.state.loading = true;
      let reponse = await Ajax.get("/api/services/app/Category/GetAll", {
        params: payload.data,
      });
      context.state.loading = false;
      let page = reponse.data.result as PageResult<Category>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    async create(context: ActionContext<CategoryState, any>, payload: any) {
      await Ajax.post("/api/services/app/Category/Create", payload.data);
    },
    async update(context: ActionContext<CategoryState, any>, payload: any) {
      await Ajax.put("/api/services/app/Category/Update", payload.data);
    },
    async delete(context: ActionContext<CategoryState, any>, payload: any) {
      await Ajax.delete(
        "/api/services/app/Category/Delete?Id=" + payload.data.id
      );
    },
    async get(context: ActionContext<CategoryState, any>, payload: any) {
      let reponse = await Ajax.get(
        "/api/services/app/Category/Get?Id=" + payload.id
      );
      return reponse.data.result as Category;
    },
    async getListForSelect(
      context: ActionContext<CategoryState, any>,
      payload: any
    ) {
      let reponse = await Ajax.get(
        "/api/services/app/Category/GetCategoriesForSelect",
        { params: payload.data }
      );
      context.state.categoriesForSelect = reponse.data.result
        .items as CategoryForSelect[];
    },
    async getParentListForSelect(
      context: ActionContext<CategoryState, any>,
      payload: any
    ) {
      let reponse = await Ajax.get(
        "/api/services/app/Category/GetParentCategoriesForSelect",
        { params: payload.data }
      );
      context.state.parentCategoriesForSelect = reponse.data.result
        .items as CategoryForSelect[];
    },
    async export(context: ActionContext<CategoryState, any>, payload: any) {
      window.open(
        `${
          appconst.remoteServiceBaseUrl
        }export/exportCategories${abp.utils.buildQueryString(
          Object.keys(payload.data).map((key) => {
            return {
              name: key,
              value: payload.data[key],
            };
          }),
          true
        )}`,
        "_blank"
      );
    },
    async getCategoriesByClientForSelect(
      context: ActionContext<CategoryState, any>,
      payload: any
    ) {
      let reponse = await Ajax.get(
        "/api/services/app/Category/GetCategoriesByClientForSelect",
        { params: payload.data }
      );
      context.state.categoriesOfClientForSelect = reponse.data.result
        .items as CategoryForSelect[];
    },
  };
  mutations = {
    setCurrentPage(state: CategoryState, page: number) {
      state.currentPage = page;
    },
    setPageSize(state: CategoryState, pagesize: number) {
      state.pageSize = pagesize;
    },
    edit(state: CategoryState, category: Category) {
      state.editCategory = category;
    },
  };
}
const categoryModule = new CategoryModule();
export default categoryModule;
